export default "__VITE_ASSET__5b2acc55__"